import React from 'react';
import about from '../images/about_org.jpg';
import app from '../images/app-develop.jpg';
import { useDocTitle } from '../components/CustomHook';
import CommonContainer from "../components/CommonContainer";
import { commonStyles } from "../pages/commonStyles";
function Application() {
  useDocTitle('Application Development');

  return (
    <div>
      {/* Hero Section */}
     <div className="relative overflow-hidden mt-4 lg:mt-0 h-[320px] md:h-[380px] lg:h-[450px]">
        <div className="absolute inset-0 z-0">
          <img
            src={about}
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="absolute inset-0 bg-black bg-opacity-50 z-10"></div>

        <div className="relative z-20 h-full flex items-center justify-center text-center text-white">
  <h2 className={`${commonStyles.pageTitle} text-white`}>
    Application Development
  </h2>
</div>
      </div>
<CommonContainer>
      {/* Section Title */}
      {/* <div className="mt-16">
        <p className="text-3xl md:text-4xl lg:text-[25px] font-bold text-blue-900 mb-8 text-left pl-2">
  Application Development
</p>
      </div> */}

      {/* Main Content */}
     <div className="flex flex-col lg:flex-row items-center my-8 gap-8">
        {/* Image */}
        <div className="w-full lg:w-1/2 my-5">
          <img
            src={app}
            alt="Development"
            className="w-full h-auto object-cover rounded-lg shadow-lg"
          />
        </div>

        {/* Text */}
       <div className="lg:w-1/2">
       <h1 className={`${commonStyles.heading} mb-6`}>
    Application Development
  </h1>
          <p className={`${commonStyles.paragraph} mb-4`}>
            QuadProsoft's Application Development services offer a wide range of
            development-related capabilities, including architecting, UI design,
            product development, version upgrades, quality assurance, etc.
            QuadProsoft's offshore development center in Chennai has the high-end
            technological infrastructure required to meet all your
            development-related needs.
          </p>

          <p className={`${commonStyles.paragraph} mb-4`}>
            Combined with our consulting expertise, our Application Development
            offering could really take the pain out of your product development /
            enhancement requirements. From the initial study of your requirements
            in terms of technology, functionality, architecture, and scale to the
            final delivered product, we can ensure comprehensive ROI within a very
            rapid framework of time and investment.
          </p>
        </div>
      </div>

      {/* Services List */}
      <div>
        <p className={`${commonStyles.paragraph} mb-4`}>
          Our Application Development services include:
        </p>

        <div className="mt-10">
          <ul className="space-y-6 md:space-y-8 ml-6 md:ml-12 lg:ml-28">
            {[
              'Custom Integrated Services',
              'Product Development / Enhancement',
            ].map((item) => (
              <li
                key={item}
               className="flex items-start text-[18px] leading-8 text-gray-600"
              >
                <span className="text-green-500 text-xl mr-3 mt-1">✔</span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="my-10">
          <p className={`${commonStyles.paragraph} mb-4`}>
            To find out more about our consulting capabilities, please{' '}
            <a href="/contact" className="text-blue-500 hover:underline">
              contact us
            </a>.
          </p>
        </div>
      </div>
      </CommonContainer>
    </div>
  );
}

export default Application;
